import React, { memo, useCallback, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { createUseStyles, Input, Select, Slider } from '@Sage/hoi-poi-ui';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'EditForm');

const EditForm = ({ form, onBlur, onChange, modalInputRef, className, schema }) => {
    const classes = useStyles();
    const { values, errors, touched } = form;

    useEffect(() => {
        modalInputRef?.current?.focus();
    }, [modalInputRef]);

    const handleOnChange = useCallback(
        (field) => (value) => {
            onChange &&
                onChange({
                    field,
                    value,
                });
        },
        [onChange],
    );

    const parseFormSchema = useMemo(() => {
        return schema.map((field, index) => {
            const { placeholder, label, name, isRequired, isFullWidth, isReadOnly } = field;
            let Field = null;
            let fieldProps = {
                placeholder,
                label,
                isRequired,
                isFullWidth,
                isReadOnly,
                ref: index === 0 ? (ref) => (modalInputRef.current = ref) : undefined,
                value: values && values[name],
                onChange: handleOnChange(name),
                onBlur: (value) => onBlur({ field: name, value }),
                error: touched[name] && errors[name],
            };
            switch (field.type) {
                case 'text':
                    Field = Input;
                    break;
                case 'select':
                    Field = Select;
                    fieldProps = {
                        ...fieldProps,
                        isClearable: false,
                        options: field.attrs.options,
                    };
                    break;
                case 'slider':
                    Field = Slider;
                    fieldProps = {
                        ...fieldProps,
                        tipFormatter: field.tipFormatter,
                        overrides: field.attrs?.overrides,
                        step: field.step || 1,
                    };
                    break;
                default:
                    return Field;
            }
            return <Field key={`edit-${name}-${index}`} {...fieldProps} />;
        });
    }, [errors, handleOnChange, modalInputRef, onBlur, schema, touched, values]);

    return <div className={classNames(classes.root, className)}>{parseFormSchema}</div>;
};

export default memo(EditForm);
